import styled from '@emotion/styled';
import {MainTitleDark, TextSmall, colors, Submit} from 'ui';
import {mq} from 'ui/config';

export const Container = styled('div')({
  marginLeft: 20,
  marginRight: 20,
  marginBottom: 14,
  width: '100%',
  maxWidth: 'calc(100vw - 50px)',
});

export const BorderContainerWrapper = styled('div')({
  border: `1px solid ${colors.caramel}`,
  marginBottom: 20,
  backgroundColor: 'white',
});

export const BorderContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  border: `1px solid ${colors.caramel}`,
  margin: 4,
  padding: 20,
  paddingBottom: 22,
});

export const Title = styled(MainTitleDark)({
  fontSize: 33,
  lineHeight: 1,
  padding: 0,
  marginTop: 30,
  marginBottom: 4,
});

export const Small = styled(TextSmall)({
  color: colors.darkBrown,
  textAlign: 'center',
  marginBottom: 8,
});

export const Button = styled(Submit)({
  width: 'min-content',
  marginTop: 25,
  whiteSpace: 'nowrap',
  '& span': {
    paddingLeft: 12,
    paddingRight: 12,
    textAlign: 'center',
    [mq('small')]: {
      paddingLeft: 8,
      paddingRight: 8,
      fontSize: 15,
    },
  },
});
